import styled from "styled-components";

export const PageContainer = styled.div<{ $maxWidth?: string }>`
  display: flex;
  max-width: ${({ theme, $maxWidth }) => $maxWidth || theme.customTheme.breakpoints.maxContentWidth};
  flex-direction: column;
  padding: ${({ theme }) => theme.customTheme.pxToRem(16)};
  margin: 0 auto;

  ${({ theme }) => theme.customTheme.breakpoints.up("sm")} {
    align-items: center;
  }
`;
